/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { proposalsGetApiV3ProposalsCount } from "../../funcs/proposalsGetApiV3ProposalsCount.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$proposalsGetApiV3ProposalsCount: ToolDefinition = {
  name: "proposals-get-api-v3-proposals-count",
  description: ``,
  tool: async (client, ctx) => {
    const [result, apiCall] = await proposalsGetApiV3ProposalsCount(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
